<template>
  <div style="background-color: #232d3f; border-bottom: 1px solid #323E53;" class="pt-2 pl-2">
    <v-btn v-if="isRaceListElOverflowing" elevation="0" small class="d-inline mr-2 mt-4 float-left" color="#465169" fab
      dark @click="scrollLeft"><v-icon>mdi-chevron-left</v-icon></v-btn>
    <div class="hideBars float-left nextRaces" ref="raceListEl" style="width: 85%; overflow-x: scroll;">
      <div style="width: 1100px; overflow: hidden" class="d-flex">
        <div v-for="race in sortRaces(selectedMeeting)" :key="race.id" class="mr-2 mt-2 white--text text-center"
          elevation="0" :style="$vuetify.breakpoint.xl ? 'width: 90px' : 'width: 60px'">
          <v-badge :color="raceStatusColor(race.status)" dot overlap bordered style="width:100%"><v-card elevation="0"
              class="text-xl-h5" :color="selectedRace.id === race.id ? 'white' : '#465169'"
              :class="selectedRace.id === race.id ? 'black--text font-weight-bold mt-1 title' : 'white--text font-weight-bold mt-1 title'"
              @click="clickRace(selectedMeeting, race), $emit('close')">
              <div class="py-xl-2">{{ race.number }}</div>
              <div :style="selectedRace.id === race.id ? 'background-color:#D8621F' : 'background-color: #1e1e1e'"
                class="white--text py-xl-1 text-xl-body-2 text-caption">
                {{ formatTime(moment(race.startTime)) }}
              </div>
            </v-card></v-badge>

        </div>
      </div>
    </div>
    <v-btn v-if="isRaceListElOverflowing" elevation="0" small class="d-inline mr-2 mt-4 float-right" color="#465169" fab
      dark @click="scrollRight"><v-icon>mdi-chevron-right</v-icon></v-btn>
    <div style="clear: both"></div>
    <div class="d-flex mt-4">
      <v-card color="#232D3F" dark class="pa-1 mr-3 float-left" width="100%" max-height="65" elevation="0">
        <div class=" title d-inline orange--text">
          R{{ selectedRace.number }}
        </div>
        <v-chip class="ml-2 title-1 d-inline float-right" small label :color="raceStatusColor(selectedRace.status)">{{
          statusName(selectedRace.status) }}</v-chip>
        <div class="ml-2 title d-inline">{{ getMeetingName }}</div>
        <div class="d-inline">
          <MeetingIcon :meeting="selectedMeeting" class="raceIcon" :inverse="true" />
        </div>
        <div class="ml-2 subtitle d-inline">
          <div class="d-inline pt-4">
            <CountryFlags class=" d-inline" style="position: absolute; " :meeting="selectedMeeting" />
          </div>
          <div class="ml-10 d-inline">{{ countriesFormatted }}</div>
        </div>
        <div style="clear: both"></div>
        <div class=" caption float-left mt-1"
          :style="$vuetify.breakpoint.xl ? '' : 'max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;'">
          <span class="orange--text font-weight-bold mr-1 text-xl-body-1">Name:</span>{{ selectedRace.name }}
        </div>
        <LiveCountDown v-if="selectedRace && selectedRace.startTime && raceOpen" :key="selectedRace.startTime"
          :startTime="selectedRace.startTime" class="float-right" style="font-size: 18px; margin-left: 10px" />
        <div class="caption float-right mt-1">
          <span class="orange--text font-weight-bold  text-xl-body-1">Start Time:</span>
          {{ formatStartTime(moment(selectedRace.startTime)) }}
        </div>
      </v-card>
      <div v-if="runnerOverflow" class="scrollBtnGroup mb-4 pr-4 pt-1" style="width: 170px">
        <v-btn elevation="0" class="d-inline" fab color="#465169" dark
          @click="scrollTop"><v-icon>mdi-chevron-up</v-icon></v-btn>
        <v-btn elevation="0" class="d-inline ml-2" color="#465169" fab dark
          @click="scrollDown"><v-icon>mdi-chevron-down</v-icon></v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapGetters } from "vuex";
import LiveCountDown from "./LiveCountDown";
import CountryFlags from "./CountryFlags";
import MeetingIcon from "./MeetingIcon";
// import countries from 'i18n-iso-countries'
import cloneDeep from "clone-deep";
import { NAMINGS } from "../common/constants";


export default {
  name: "RaceHeader",
  props: {
    scrollTop: Function,
    scrollDown: Function,
    runnerOverflow: Boolean,
  },
  components: {
    LiveCountDown,
    CountryFlags,
    MeetingIcon,
  },
  data() {
    return {
      racelistClientWidth: 0,
    };
  },
  computed: {
    ...mapGetters(["getSelectedRace", "getSelectedMeeting", "getVenueName"]),
    selectedRace() {
      return this.getSelectedRace || {};
    },
    selectedMeeting() {
      return this.getSelectedMeeting || {};
    },
    getMeetingName() {
      return this.selectedMeeting?.track?.name;
    },
    raceOpen() {
      return this.getSelectedRace.status === "OPEN";
    },
    countriesFormatted() {
      // countries.registerLocale(require('i18n-iso-countries/langs/en.json'))
      return this.selectedMeeting?.track?.country || "";
    },
    raceListWidth() {
      return this.sortRaces(this.selectedMeeting).length * 68;
    },
    isRaceListElOverflowing() {
      return this.racelistClientWidth < this.raceListWidth && !this.$vuetify.breakpoint.xl;
    },
  },
  mounted() {
    this.racelistClientWidth = this.$refs.raceListEl.clientWidth;
    const widthob = new ResizeObserver((entries) => {
      for (let entry of entries) {
        this.racelistClientWidth = entry.target.clientWidth;
      }
    });
    widthob.observe(this.$refs.raceListEl);
  },

  methods: {
    ...mapActions(["selectMeeting", "selectRace"]),
    scrollLeft() {
      let content = document.querySelector(".nextRaces");
      content.scrollLeft -= 150;
    },
    scrollRight() {
      let content = document.querySelector(".nextRaces");
      content.scrollLeft += 150;
    },
    statusName(v) {
      const name = NAMINGS;
      const status = name.find(
        (c) => c.word === v && c.venueName === this.getVenueName
      )?.replaceWith;
      return status || v;
    },
    moment,
    formatStartTime: function (date) {
      return moment(date, "YYYY-MM-DD H:mm:ss").format("LLL");
    },
    sortRaces(meeting) {
      if (!meeting || !meeting?.races) return [];
      const races = meeting?.races;
      const sortedRaces = cloneDeep(races);
      return sortedRaces?.sort(function (a, b) {
        return a.number - b.number;
      });
    },
    async clickRace(meeting, race) {
      this.selectMeeting(meeting.id);
      //const nextToGoInMeeting = v.races.find(race => race.status === 'selling');
      this.selectRace(race.id);
      // this.loadRunners (race)
    },
    raceStatusColor: function (raceStatus) {
      if (raceStatus === "FINAL") {
        return "#000";
      } else if (raceStatus === "OPEN") {
        return "#049B5E";
      } else if (raceStatus === "ABANDONED") {
        return "error";
      } else if (raceStatus === "CLOSED") {
        return "#333";
      } else if (raceStatus === "INTERIM") {
        return "warning";
      }
    },
    formatTime: function (date) {
      return moment(date, "YYYY-MM-DD H:mm:ss").format("LT");
    },
  },
};
</script>

<style scoped>
.raceIcon {
  transform: scale(0.7);
}
</style>